export const setCookie = (name, value, days = 30) => {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = `expires=${date.toUTCString()}`;
    const domain = getDomain();
    document.cookie = `${name}=${value};${expires};path=/;domain=${domain};SameSite=Lax`;
    //document.cookie = `${name}=${value};${expires};path=/;SameSite=None;Secure`;
};

// Get the root domain (e.g., readyrx.com from any subdomain)
export const getDomain = () => {
    const hostname = window.location.hostname;
    const parts = hostname.split('.');
    const mainDomain = parts.slice(-2).join('.');
    return '.readyrx.com';
    //return `.${mainDomain}`; // Adding dot prefix allows cookie to work on all subdomains
};

export const getCookie = (name) => {
    const nameEQ = `${name}=`;
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
};

export const deleteCookie = (name) => {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;SameSite=Lax`;
};